export default __webpack_public_path__ + "static/media/Facebook.f51db061.svg";